export const CALL_ENDED = 'CALL_ENDED';
export const WBR_WRAPPER = 'WBR_WRAPPER';
export const IS_WEBINAR_INSTANCE = 'IS_WEBINAR_INSTANCE';

export const GET_MODERATOR_ITEM = 'GET_MODERATOR_ITEM';
export const IS_SHOW_ALLOW_CHATS_DROPDOWN = 'IS_SHOW_ALLOW_CHATS_DROPDOWN';
export const FILTER_GALLERY_MODE = 'FILTER_GALLERY_MODE';
export const SET_WBR_GALLERY_MODE = 'SET_WBR_GALLERY_MODE';
export const LEAVE_TO_WEBINAR = 'LEAVE_TO_WEBINAR';
export const BEACON_LEAVE_TO_WEBINAR = 'BEACON_LEAVE_TO_WEBINAR';
export const PREVENT_ROUTER_MANAGER = 'PREVENT_ROUTER_MANAGER';
export const WEBINAR_DIALOGS = 'WEBINAR_DIALOGS';
export const LIB_WEBINAR_INIT = 'LIB_WEBINAR_INIT';
export const WBR_CONVERT_FETCH_PARAMS = 'WBR_CONVERT_FETCH_PARAMS';
export const WBR_EXTEND_SDK_PARAMS = 'WBR_EXTEND_SDK_PARAMS';
export const WBR_GALLERY_COMPARE = 'WBR_GALLERY_COMPARE';
export const HI_BAR_RIGHT_CLASS = 'HI_BAR_RIGHT_CLASS';

export const GET_IS_E2EE_ENABLED = 'GET_IS_E2EE_ENABLED';
export const GET_IS_E2EE_AVAILABLE = 'GET_IS_E2EE_AVAILABLE';

// participants
export const PARTICIPANTS_LIST_EXTRA_MAP_STATE = 'PARTICIPANTS_LIST_EXTRA_MAP_STATE';
export const PARTICIPANTS_LIST_GET_COMPONENT = 'PARTICIPANTS_LIST_GET_COMPONENT';
export const GET_PARTICIPANTS_VIRTUAL_LIST = 'GET_PARTICIPANTS_VIRTUAL_LIST';
export const GET_PARTICIPANTS_LIST_ITEM_SECONDARY_LINE =
    'GET_PARTICIPANTS_LIST_ITEM_SECONDARY_LINE';
export const MAKE_PROMOTE_DEMOTE_ACTION = 'MAKE_PROMOTE_DEMOTE_ACTION';
export const RENDER_SIDEBAR_INVITE_BUTTON = 'RENDER_SIDEBAR_INVITE_BUTTON';
export const RENDER_SIDEBAR_TIMER = 'RENDER_SIDEBAR_TIMER';
export const WITH_FORMATTED_PARTICIPANTS_COUNT = 'WITH_FORMATTED_PARTICIPANTS_COUNT';
export const FILTER_PARTICIPANTS = 'FILTER_PARTICIPANTS';
export const END_TO_WEBINAR = 'END_TO_WEBINAR';
export const LEAVE_END_TO_WEBINAR = 'LEAVE_END_TO_WEBINAR';
export const END_TO_WEBINAR_EXCEPTION = 'END_TO_WEBINAR_EXCEPTION';
export const EXCLUDE_STREAM_REFS = 'EXCLUDE_STREAM_REFS';
export const GALLERY_MODES = 'GALLERY_MODES';
export const PARTICIPANTS_LIST_COUNT_SELECTOR = 'PARTICIPANTS_LIST_COUNT_SELECTOR';
export const WEBINAR_TOGGLE_FLOATER_PIN = 'WEBINAR_TOGGLE_FLOATER_PIN';
export const GET_PARTICIPANT_MORE_UPDATE = 'GET_PARTICIPANT_MORE_UPDATE';
export const GET_RENDER_MORE_OPTIONS_PROPS = 'GET_RENDER_MORE_OPTIONS_PROPS';

// component
export const MEETING_DETAILS = 'MEETING_DETAILS';
export const MORE_MENU_BUTTON = 'MORE_MENU_BUTTON';
export const GET_QNA_WRAPPER = 'GET_QNA_WRAPPER';

// element hidden
export const IS_INVITE_HIDDEN_SELECTOR = 'IS_INVITE_HIDDEN_SELECTOR';
export const IS_BREAKOUT_ROOM_HIDDEN_SELECTOR = 'IS_BREAKOUT_ROOM_HIDDEN_SELECTOR';
export const IS_CLOSED_CAPTIONS_HIDDEN_SELECTOR = 'IS_CLOSED_CAPTIONS_HIDDEN_SELECTOR';
export const IS_RECORD_HIDDEN_SELECTOR = 'IS_RECORD_HIDDEN_SELECTOR';
export const IS_GENERAL_HIDDEN_SELECTOR = 'IS_GENERAL_HIDDEN_SELECTOR';
export const IS_CALENDAR_HIDDEN_SELECTOR = 'IS_CALENDAR_HIDDEN_SELECTOR';
export const IS_PERSONAL_MEETING_HIDDEN_SELECTOR = 'IS_PERSONAL_MEETING_HIDDEN_SELECTOR';
export const IS_DELEGATES_HIDDEN_SELECTOR = 'IS_DELEGATES_HIDDEN_SELECTOR';
export const IS_DIAL_IN_HIDDEN_SELECTOR = 'IS_DIAL_IN_HIDDEN_SELECTOR';
export const IS_CALL_ME_HIDDEN_SELECTOR = 'IS_CALL_ME_HIDDEN_SELECTOR';
export const IS_AUDIO_PREFERENCE_HIDDEN_SELECTOR = 'IS_AUDIO_PREFERENCE_HIDDEN_SELECTOR';
export const HANGUP_BLOCK = 'HANGUP_BLOCK';
export const EXTRA_BLOCK = 'EXTRA_BLOCK';
export const BUTTONS_WITHOUT_WAITING_ROOM_BLOCK = 'BUTTONS_WITHOUT_WAITING_ROOM_BLOCK';
export const LEAVE_HOOKS = 'LEAVE_HOOKS';
export const BANNER_MANAGER = 'BANNER_MANAGER';
export const GET_BANNER_LIFETIME = 'GET_BANNER_LIFETIME';
export const ALLOW_JOIN = 'ALLOW_JION';
export const DISALLOW_JOIN = 'DISALLOW_JOIN';
export const GET_IS_JOIN_LOCKED = 'GET_IS_JOIN_LOCKED';
export const RENDER_INVITE_BUTTON = 'RENDER_INVITE_BUTTON';
export const PROVIDE_INIT_CALL_WBR = 'PROVIDE_INIT_CALL_WBR';
export const RCV_JOIN_READY = 'RCV_JOIN_READY';
export const REMOVE_DIALOG_CLOSE_MASK = 'REMOVE_DIALOG_CLOSE_MASK';
export const REMOVE_MEETING_INFO_FETCHER = 'REMOVE_MEETING_INFO_FETCHER';

//recording
export const HIDDEN_RECORDING_MARK = 'HIDDEN_RECORDING_MARK';
export const START_RECORDING = 'START_RECORDING';
export const STOP_RECORDING = 'STOP_RECORDING';
export const UPDATE_LOCAL_RECORD = 'UPDATE_LOCAL_RECORD';
export const DISABLE_LOCAL_RECORD = 'DISABLE_LOCAL_RECORD';
export const ENABLE_CLOUD_RECORDING = 'ENABLE_CLOUD_RECORDING';
export const RECORD_RED_MARK = 'RECORD_RED_MARK';
export const RECORD_BUTTON_TEXT = 'RECORD_BUTTON_TEXT';
export const RECORD_BUTTON_ITEM = 'RECORD_BUTTON_ITEM';
export const MORE_RECORD_BUTTON_ITEM = 'MORE_RECORD_BUTTON_ITEM';
export const GET_CLASS_NAME_OF_RECORD_BUTTON_IN_MORE = 'GET_CLASS_NAME_OF_RECORD_BUTTON_IN_MORE';

// export const WBR_AUTO_RECORDING = 'WBR_AUTO_RECORDING';
export const QNA_TOGGLE = 'QNA_TOGGLE';
export const QNA_TOGGLE_IN_MORE_BTN = 'QNA_TOGGLE_IN_MORE_BTN';

// polls
export const POLLS_TOGGLE = 'POLLS_TOGGLE';
export const POLLS_TAB = 'POLLS_TAB';
export const POLLS_TOGGLE_IN_MORE_BTN = 'POLLS_TOGGLE_IN_MORE_BTN';

// welcome screen should close or redirect
export const REDIRECT_OR_CLOSE_STATE_TO_PROPS = 'REDIRECT_OR_CLOSE_STATE_TO_PROPS';
export const REDIRECT_TO_RCV_WELCOME_OR_CLOSE_WINDOW = 'REDIRECT_TO_RCV_WELCOME_OR_CLOSE_WINDOW';
export const GET_REDIRECT_OR_CLOSE_PROP_TYPES = 'GET_REDIRECT_OR_CLOSE_PROP_TYPES';
export const CLOSE_OR_REDIRECT_IF_JOIN_API_ERROR = 'CLOSE_OR_REDIRECT_IF_JOIN_API_ERROR';
export const GUARD_WELCOME = 'GUARD_WELCOME';
export const REDIRECT_WELCOME = 'REDIRECT_WELCOME';

// reducers
export const GET_EXTRA_REDUCERS = 'GET_EXTRA_REDUCERS';

// feature flags
export const GET_TRANSCRIPT_AVAILABLE = 'GET_TRANSCRIPT_AVAILABLE';

// edr
export const OTHER_EDR_DATA = 'OTHER_EDR_DATA';

// guard
export const IS_RCV_OR_CURRENT_CLIENT_SUPPORT = 'IS_RCV_OR_CURRENT_CLIENT_SUPPORT';
export const NO_INSTALL_AND_CLIENT_NOT_SUPPORT = 'NO_INSTALL_AND_CLIENT_NOT_SUPPORT';
export const IS_FORCE_DOWNLOAD = 'IS_FORCE_DOWNLOAD';
export const CHECK_GUEST_USER = 'CHECK_GUEST_USER';
export const GET_MOBILE_APPLICATION_URI = 'GET_MOBILE_APPLICATION_URI';
export const IS_TRY_LAUNCH_FOR_DEFAULT = 'IS_TRY_LAUNCH_FOR_DEFAULT';

// low
export const IS_CLIENT_SUPPORT = 'IS_CLIENT_SUPPORT';
export const GET_LAUNCH_URL = 'GET_LAUNCH_URL';
export const IS_RAISED_HAND = 'IS_RAISED_HAND';

// download
export const GET_MEETING_URL = 'GET_MEETING_URL';
export const DOWNLOAD_JOIN_BUTTON_DISABLED = 'DOWNLOAD_JOIN_BUTTON_DISABLED';
export const IS_NAME_INPUT_SHOW = 'IS_NAME_INPUT_SHOW';

// launcher
export const RENDER_LAUNCHERINFO = 'RENDER_LAUNCHERINFO';

// modals
export const WBR_FULL_SCREEN_MODALS = 'WBR_FULL_SCREEN_MODALS';
export const WBR_HEADERLESS_MODALS = 'WBR_HEADERLESS_MODALS';
export const WBR_NON_CLOSABLE_MODALS = 'WBR_NON_CLOSABLE_MODALS';

// unsupported
export const RENDER_UNSUPPORTED = 'RENDER_UNSUPPORTED';

// onconf
export const INIT_LAYOUT_MODE = 'INIT_LAYOUT_MODE';
export const WEBINAR_VERIFIED_ON_CONF = 'WEBINAR_VERIFIED_ON_CONF';
export const COMMON_EDR_DATA = 'COMMON_EDR_DATA';

// participant role
export const SET_MODERATOR = 'SET_MODERATOR';
export const UNSET_MODERATOR = 'UNSET_MODERATOR';

export const RCT_GET_LOCAL_PARTICIPANT = 'RCT_GET_LOCAL_PARTICIPANT';
export const RCT_GET_PARTICIPANTS_BY_ID = 'RCT_GET_PARTICIPANTS_BY_ID';
export const GET_NONE_MODERATORS = 'GET_NONE_MODERATORS';
// feedback page
export const FEEDBACK_PAGE = 'FEEDBACK_PAGE';

export const GET_FLOATER_WIDTH = 'GET_FLOATER_WIDTH';
export const GET_FLOATER_MIN_WIDTH = 'GET_FLOATER_MIN_WIDTH';
export const GET_FLOATER_X = 'GET_FLOATER_X';
export const GET_SIDEBAR_WIDTH = 'GET_SIDEBAR_WIDTH';
export const GET_VIEWPORT_WIDTH = 'GET_VIEWPORT_WIDTH';

// data tracking
export const DATA_TRACKING_EXTRA_INFO = 'DATA_TRACKING_EXTRA_INFO';
export const OTHER_EVENT_TRACK = 'OTHER_EVENT_TRACK';
export const GET_NAV_BAR_EXTRA_ITEMS_KEY = 'GET_NAV_BAR_EXTRA_ITEMS_KEY';
export const GET_NAV_BAR_EXTRA_ITEMS = 'GET_NAV_BAR_EXTRA_ITEMS';
export const GET_SELECTED_NAV_BAR_ITEM = 'GET_SELECTED_NAV_BAR_ITEM';
export const VERIFIED_AUTH_CODE_FAILED = 'VERIFIED_AUTH_CODE_FAILED';

//chat
export const CHAT_TOGGLE = 'CHAT_TOGGLE';

// tab
export const TAB_SWITCH = 'TAB_SWITCH';
export const USE_ON_TAB_SELECT = 'USE_ON_TAB_SELECT';

export const NOTIFY_TEMPORARY_SUPER_CHANGE = 'NOTIFY_TEMPORARY_SUPER_CHANGE';

// pstn
export const GET_PSTN_PASSWORD = 'GET_PSTN_PASSWORD';
export const GET_SHORT_PARTICIPANT_ID = 'GET_SHORT_PARTICIPANT_ID';
export const GET_PHONE_NUMBER_LIST = 'GET_PHONE_NUMBER_LIST';

export const GET_IS_READY_FOR_PERMISSIONS_CHECK = 'GET_IS_READY_FOR_PERMISSIONS_CHECK';
export const WBR_NO_SIGN_URL_CHECK = 'WBR_NO_SIGN_URL_CHECK';
export const BACK_WHEN_OTHER_TABS_SIGN_IN = 'BACK_WHEN_OTHER_TABS_SIGN_IN';
export const NO_SIGN_TOKEN_INITIAL = 'NO_SIGN_TOKEN_INITIAL';
export const GET_INITIAL_I18N = 'GET_INITIAL_I18N';
export const GET_LONG_LOCALE = 'GET_LONG_LOCALE';
export const HI_BAR = 'HI_BAR';

export const RELATIVE_LOWER_BAR_ELEMENTS = 'RELATIVE_LOWER_BAR_ELEMENTS';

export const GET_GUEST_TOKEN_BODY = 'GET_GUEST_TOKEN_BODY';

export const VERSION_CANARY_RELEASE_MANAGER = 'VERSION_CANARY_RELEASE_MANAGER';

// feature flag controller override
export const INJECT_WEBINAR_FF_CONTROLLER = 'INJECT_WEBINAR_FF_CONTROLLER';
export const BANNER_TAP_PARTICIPANT_HANGUP = 'BANNER_TAP_PARTICIPANT_HANGUP';

export const GET_IS_FULL_SCREEN = 'GET_IS_FULL_SCREEN';

export const GET_WEBINAR_BSS_CONFIG = 'GET_WEBINAR_BSS_CONFIG';

export const GET_WEBINAR_LOCAL_BSS_CONFIG = 'GET_WEBINAR_LOCAL_BSS_CONFIG';

export const PARTICIPANT_AVATAR = 'PARTICIPANT_AVATAR';

export const START_GET_ACCOUNT_INFO = 'START_GET_ACCOUNT_INFO';

// firefox
export const WITH_FIREFOX_HIDDEN_ENTRANCE = 'WITH_FIREFOX_HIDDEN_ENTRANCE';

export const SHOW_SERVICE_UNAVAILABLE = 'SHOW_SERVICE_UNAVAILABLE';
export const GET_URL_QUERY_PARAM = 'GET_URL_QUERY_PARAM';

export const DATA_TRACK_OPEN_MEETING_DETAILS = 'DATA_TRACK_OPEN_MEETING_DETAILS';
